<template>
    <div>
        <nav class="level" v-if="OPDSelected">
            <div class="level-item has-text-centered " v-if="showLabNo">
                <div>
                    <p class="heading is-size-6 has-text-info">Lab Order No.</p>
                    <p class="title is-size-6 has-text-success">{{idlab}}</p>
                </div>
            </div>
            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">OPD No.</p>
                    <p class="title is-size-6"   >{{OPDSelected.idopd}}</p>
                </div>
            </div>

            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Pet Name</p>
                    <p class="title is-size-6" >{{OPDSelected.opdname}}</p>
                </div>
            </div>

            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Species/Breed</p>
                    <p class="title is-size-6"  >{{OPDSelected.type}}</p>
                </div>
            </div>


            <div class="level-item has-text-centered">
                <div >
                    <p class="heading is-size-6 has-text-info" >Gender</p>
                    <b-icon pack="fas"  type="is-text" :icon="OPDSelected.gender === 'M' ? 'mars' : 'venus'" > </b-icon> &nbsp;
                </div>
            </div>


            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Age</p>
                    <p class="title is-size-6"  >{{OPDSelected.age}}</p>
                </div>
            </div>



            <div class="level-item has-text-centered">
                <div>
                    <p class="heading is-size-6 has-text-info">Owner Name</p>
                    <p class="title is-size-6"  >{{OPDSelected.owner_name}}</p>
                </div>
            </div>




        </nav>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "HeaderDecorate",
        computed:{
            ...mapState({
                OPDSelected : state => state.opd_target.opd_selected,
            })
        },
        props:{
            idlab : String,
            showLabNo : Boolean
        }
    }
</script>

<style scoped>

</style>